<template>
    <!--Client Waiting List Page-->
    <div class="client-final-step">
        <!--Step Four-->
        <div class="client-final-step-wrap section-wrap">
            <!--Subtitle-->
            <h5>{{ $ml.get("waitingList.title") }} - {{ currentWaitingListStylist.first_name }}, {{
                currentWaitingListStylist.last_name }}</h5>
            <div class="steps">
                <p class="highlight-text">{{ $ml.get("waitingListClient.stepOne") }}</p>
                <i class="fa fa-check-circle-o" aria-hidden="true"></i>
            </div>
            <div class="steps">
                <p class="highlight-text">{{ $ml.get("waitingListClient.stepTwo") }}</p>
                <i class="fa fa-check-circle-o" aria-hidden="true"></i>
            </div>
            <div class="steps">
                <p class="highlight-text">{{ $ml.get("waitingListClient.stepThree") }}</p>
                <i class="fa fa-check-circle-o" aria-hidden="true"></i>
            </div>
            <div class="steps">
                <p class="highlight-text">{{ $ml.get("waitingListClient.stepFour") }}</p>
                <i class="fa fa-check-circle-o" aria-hidden="true"></i>
            </div>
            <div class="client-final-step-wrap" v-if="!loading">
                <div class="congratulation section-wrap">
                    <p>You're all set!</p>
                    <!-- <p>Sit back and relax-we’ll notify you as soon as an appointment becomes available.</p> -->
                    <div class="congrat-image-wrap">
                        <img src="../../../../../assets/images/enrollment-congratiulation.png" alt="Congratiulation">
                    </div>
                </div>
                <div class="next-btn" >
                    <button type="button"
                        class="primary-btn extra-small mobile" @click="changeSection('client-wlist')">
                        {{ $ml.get("general.finish") }}
                    </button>
                </div>
            </div>
            <main-loader v-if="loading"></main-loader>
        </div>
    </div>
</template>

<script>
import store from "../../../../../services/vuex";
import MainLoader from "../../../general-components/main_loader.vue";

export default {
    data() {
        return {
            notificationTime: '',
            loading: false,
        };
    },
    computed: {
        currentWaitingListStylist: {
            get: function () {
                return store.state.currentWaitingListStylist;
            },
            set: function (value) {
                store.commit("setCurrentWaitingListStylist", value);
            },
        },
    },
    mounted() {
        this.addLoader();
    },
    components: { MainLoader, },
    methods: {
        changeSection(section) {
            this.$emit('change-section', section);
        },
        addLoader() {
            this.loading = true;

            setTimeout(() => {
                this.loading = false;
            }, 500);
        }

    },
};
</script>
